import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultClientGrievances = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultClientGrievances' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> CLIENT GRIEVANCES  </center> </b>
                </p>
                <p className='w-750'>
                    <b> PURPOSE OF CLIENT GRIEVANCE PROCEDURE </b> Jackson Hands of Change fully trains staff to be compassionate and attentive to the concerns of the persons serviced.  This facilitates a comfort level being established that allows persons serviced to openly communicate and pursue resolutions through the information and channels that are available to them.  It is our responsibility to ensure that each person served is afforded due process regarding rights and services. When persons served are fully informed,  regarding their rights, this will assist persons served with needs to file a complaint or grievance should it become apparent.
                </p>
                <p className='w-750'>
                    <b>POLICY </b> It is Jackson Hands of Change's policy to ensure clients can submit a grievance without fear of retaliation and understand the procedures for filing a grievance, the agency's time line for responding to the grievance, the agency's method for responding to a grievance, and the staff's responsibilities for addressing grievances.
                </p>
                <p className='w-750'>
                    <b>PROCEDURES </b>  Staff will ensure the client and, if applicable, the client's parent(s) or legal guardian(s), is informed of the grievance procedure and their right to voice a grievance during the orientation process.   During a formal grievance process, you have the right to representation of your choice, the right to review information obtained in processing the grievance, except that which would violate the confidentiality of another person, and presentation of evidence of witness pertinent to the grievance.

                    <ol>
                        <li>First discuss the concern with the staff.</li>
                        <li>If the result is not satisfactory, bring the problem to the attention of their supervisor.</li>
                        <li>If the appropriate individual does not respond within five (5) working days verbally or in writing to the client's satisfaction, then the complaint should be presented to the Administrator.</li>
                        <li>The Administrator is responsible for responding within five (5) working days.</li>
                        <li>If the resolution is not to the client's satisfaction, then the complaint shall be presented to the Corporate Compliance Officer is responsible for holding a meeting with the complainant to produce a decision.</li>
                        <li>If the client is not satisfied with the decision made by the company, the client may exercise their rights to access the final point of resolution.</li>
                        <li>The client may contact Healthy Louisiana at 1-888-342-6207 or HSS at (225) 342-0138
                            Clients are asked to inform Jackson Hands of Change if they are not happy with their services, or any decisions that are made about their treatment. They have the right to file a grievance about anything they are not happy with. Staff are responsible for encouraging and informing client they do not need to worry and will not be treated poorly for filing a grievance. Jackson Hands of Change are responsible for making sure clients are treated fairly and receive the best service possible.  Clients are informed they also have a right to appeal. All grievances are addressed and resolved to the best of the Jackson Hands of Change's ability. </li>
                    </ol>

                </p>
                <p className='w-750'>
                    <b>STEPS FOR FILING A GREIVANCE  </b>
                    <ol>
                        <li>Formal grievance should be filed first with the office manager, in Jackson Hands of change office, when the grievance arises. Using the complaint/grievance form, or the complaint an be made to the LMHP.  </li>
                        <li>The LMHP will meet with you, the grievant, and or representatives.  Immediately following the filing to braining storm possible resolutions of any related issues that may get in the way of full participation in services.  Actions may include, but are not limited to  a change in different care providers or an adjustment in programming schedules and/or program environments.  </li>
                        <li>3.	The LMHP will issue a formal written response to you, the grievant, and/or the designated representatives, within five working days of receiving the complaint.  </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b>NOTE -  </b> the Board of Directors is the last appeal process in the agency.  You will be informed of any external appeal process that is open to you if they were not satisfied with the recommendations of the Board of Directors.  You will be provided this information in writing within 5 working days, excluding weekends.
                </p>
                <p className='w-750'>
                    <center>
                        <b>
                            Notice of Grievance Policy and Process -Acknowledgment Form
                            <br />
                            AGENCY: Jackson Hands of Change
                        </b>
                    </center>
                </p>

                <p className='w-750'>
                    <b>


                        I have received a copy of the Jackson Hands of Change  Notice of Grievance Policy and Process Practices (Effective Date

                        <input type='date' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only w-200 custom-add-only' />
                        )</b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}